import {
  LayoutDashboard,
  Users,
  Shield,
  FileText,
  CreditCard,
  BarChart3,
  Bell,
  HelpCircle,
  LogOut,
  UserCheck,
  Building2,
  Calendar,
  TrendingUp,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  MapPin,
  Speech,
  Newspaper,
  GraduationCap,
  Briefcase,
} from "lucide-react";

/**
 * Icon mappings for easy reference
 */
export const NAV_ICONS = {
  LayoutDashboard,
  Users,
  Shield,
  FileText,
  CreditCard,
  BarChart3,
  Bell,
  HelpCircle,
  LogOut,
  UserCheck,
  Building2,
  Calendar,
  TrendingUp,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  MapPin,
  Speech,
  Newspaper,
  GraduationCap,
  Briefcase,
};

export const BASE_PATHS = {
  ADMIN: "/admin",
  DASHBOARD: "/admin/dashboard",
  AGENTS: "/admin/agents",
  USERS: "/admin/users",
  INSURANCE: "/admin/insurance",
  PROVIDERS: "/admin/providers",
  PAYMENTS: "/admin/payments",
  PURCHASES: "/admin/purchases",
  ANALYTICS: "/admin/analytics",
  REPORTS: "/admin/reports",
  HELP: "/admin/help",
  MEDIA: "/admin/media",
};
